/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dusty_Dusty_Whale_SinkInputs */

const en_dusty_dusty_whale_sink = /** @type {(inputs: Dusty_Dusty_Whale_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value calculation in progress`)
};

const de_dusty_dusty_whale_sink = /** @type {(inputs: Dusty_Dusty_Whale_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werteberechnung läuft`)
};

/**
* | output |
* | --- |
* | "Value calculation in progress" |
*
* @param {Dusty_Dusty_Whale_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dusty_dusty_whale_sink = /** @type {((inputs?: Dusty_Dusty_Whale_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dusty_Dusty_Whale_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dusty_dusty_whale_sink(inputs)
	return de_dusty_dusty_whale_sink(inputs)
});